import clsx from 'clsx'

import { UnderlineLink } from '@/shared/ui'

import { loyaltyMenuItems, otherMenuItems } from '../data'

import cl from './style.module.scss'

export const HeaderCategoriesLinks = () => {
	return (
		<div className={cl.links}>
			{!!loyaltyMenuItems.length && (
				<div className={cl.links_main}>
					{loyaltyMenuItems.map(item => (
						<UnderlineLink href={item.link} key={item.link} className={clsx(cl.link)}>
							{item.title}
						</UnderlineLink>
					))}
				</div>
			)}

			{!!otherMenuItems.length && (
				<div className={cl.links_extra}>
					{otherMenuItems.map(item => (
						<UnderlineLink href={item.link} key={item.link} className={clsx(cl.link)}>
							{item.title}
						</UnderlineLink>
					))}
				</div>
			)}
		</div>
	)
}
